module.exports = __webpack_public_path__ + "images/emoji/wheelchair.afbbac2c0270066f2566.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wheelchair.png
// module id = eUNf
// module chunks = 13